import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsAppButton from "./FloatingWhatsAppButton";

const TITLES = {
  "/": "Ascend Tech Solution | IT & Non-IT Recruitment Consultancy in Pune",
  "/about": "About Ascend Tech Solution | Recruitment Consultancy Pune",
  "/services": "IT & Non-IT Recruitment Services | Ascend Tech Solution",
  "/contact": "Contact Ascend Tech Solution | Pune, Maharashtra",
};

const DESCRIPTIONS = {
  "/": "Ascend Tech Solution is a Pune-based recruitment consultancy supporting IT and Non-IT hiring, talent sourcing and workforce recruitment needs.",
  "/about":
    "Learn about Ascend Tech Solution, a people-first recruitment consultancy based in Pune, Maharashtra, supporting IT and Non-IT hiring.",
  "/services":
    "Explore recruitment solutions across IT, Non-IT, permanent hiring, bulk hiring, talent sourcing and recruitment process support.",
  "/contact":
    "Contact Ascend Tech Solution for recruitment support, hiring requirements or career opportunities across IT and Non-IT sectors.",
};

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const key = location.pathname.replace(/\/$/, "") || "/";
    document.title = TITLES[key] || TITLES["/"];
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", DESCRIPTIONS[key] || DESCRIPTIONS["/"]);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsAppButton />
    </div>
  );
}
